module.exports = __webpack_public_path__ + "media/images/logo_moneymonk-28eb4bac8c3102d608f7ec51bdcfe857.svg";